import { DocumentNode, gql, useQuery } from '@apollo/client';

export const LIST_LOSS_RUN_REPORTS = gql`
  query listLossRunReports($entityUuid: String!) {
    listLossRunReports(entityUuid: $entityUuid) {
      storageBaseUrl
      totalReports
      reports {
        filename
        reportType
        createdAt
        createdByUser
      }
    }
  }
`;

export function useListLossRunReportsQuery(entityUuid: string, options = {}) {
  const { ...queryOptions } = options;

  return useQuery(LIST_LOSS_RUN_REPORTS as DocumentNode, {
    variables: { entityUuid },
    ...queryOptions,
  });
}
